const fields = {
  global: {
    required: 'Campo Obrigatório',
    invalid: 'Campo inválido',
    mismatch: 'Os campos não correspondem',
    minSixChars: 'Mínimo 6 caracteres',
  },
  email: {
    required: 'O endereço de E-mail é obrigatório',
    invalid: 'O endereço de E-mail informado não é válido',
  },
  password: {
    invalid: 'Senha inválida',
    required: 'A senha é obrigatória',
    minSixChars: 'A senha deve conter no mínimo 6 caracteres',
    mismatch: 'As senhas digitadas não são iguais',
  },
};

export default fields;
